// extracted by mini-css-extract-plugin
export default {"closeModalButton":"ArchiveFormPopup_closeModalButton__nATnq","modalTitle":"ArchiveFormPopup_modalTitle__2m06O","buttonSection":"ArchiveFormPopup_buttonSection__ElLBG"};